<ng-container *ngIf="fulfillmentCellLinkVersion && hasFulfillment; else noLinkVersion">
  <div class="badge-button-container">
    <glxy-badge [color]="badgeColor">
      {{ 'FRONTEND.SALES_UI.' + stringStatus | translate }}
    </glxy-badge>
    <button
      class="nowrap-button"
      mat-button
      color="primary"
      data-action="fulfillment-orders-link-clicked"
      (click)="handleViewItemsClick()"
    >
      <p>{{ 'SALES_ORDERS.VIEW_ITEMS' | translate }}</p>
    </button>
  </div>
</ng-container>

<ng-template #noLinkVersion>
  <glxy-badge *ngIf="stringStatus; else notApplicableOption" [color]="badgeColor">
    {{ 'FRONTEND.SALES_UI.' + stringStatus | translate }}
  </glxy-badge>
</ng-template>

<ng-template #notApplicableOption>
  <p class="not-applicable-text">N/A</p>
</ng-template>
